export enum EventCode {
  contact_site_manager = 'CONTACT_SITE_MANAGER',
  contact_interaction_manager = 'CONTACT_INTERACT_MANAGER',
  personal_data = 'PERSONAL_DATA',
  report_of_abuse = 'REPORT_OF_ABUSE',
  unconfirmed_contribution = 'UNCONFIRMED_CONTRIBUTION',
}

export interface PayloadMailType {
  eventCode: EventCode;
  attributes: {
    SUBJECT?: string;
    MESSAGE: string;
  };
}
